export default __webpack_public_path__ + "static/media/twitter_eternal.91508bf8.svg";